export default __webpack_public_path__ + "static/media/cv_css.1673cb6d.png";